export default {
    data:()=>({
        isLoading: true,
        listPendingOrderRequest: [],
        searchOrderId: '',
        orderRequestId: '',
        filterOrderRequest: {},

        // pagination
        offset: 10,
        pagination: {},
        per_page: 10,
        totalOrder: 0
    }),
    methods: {
        // Fetch Pending Order Request
        FetchPendingOrderRequest(){
            this.isLoading = true;
            this.$axiosDelivery.get('list-pending-order-requests',{
                params:{
                    page: this.pagination.current_page,
                    per_page: this.per_page
                }
            }).then((res) => {
                setTimeout(()=>{
                    this.listPendingOrderRequest = res.data.data;
                    this.pagination = res.data;
                    this.totalOrder = res.data.total;
                    this.isLoading = false;
                }, 300);
            }).catch(()=>{});
        },
        OpenModalViewOrderRequestProcessing(orderRequestId){
            this.filterOrderRequest = this.FilterOrderPending(orderRequestId);
            this.$store.commit('modalPreviewFile_State', true);
        },
        OpenModal_RejectOrderRequest(orderRequestId){
            this.orderRequestId = orderRequestId;
            this.$store.commit('modalDelete_State', true);
        },
        OpenModalUpdateOrderRequest(orderRequestId){
            this.orderRequestId = orderRequestId;
            this.$store.commit('modalEdit_State', true);
        },
        FilterOrderPending(orderRequestId){
            return this.listPendingOrderRequest.filter(item=>{
                return item.id == orderRequestId;
            })[0] || {};
        },

        EscapeRegExp(string) {
            string = string.toString()
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        },
    },
    computed:{
        FilterOrderRequestPending(){
			var item = this.EscapeRegExp(this.searchOrderId)
            const pattern = new RegExp(item, 'i')
            return this.listPendingOrderRequest.filter(item => {
                setTimeout(()=>{
                    this.isLoading = false;
                }, 300);
                return pattern.test(item.order_id);
            });
        },
    },
    // watch:{
    //     'startDate': function(){
    //         this.FetchPendingOrderRequest();
    //     },
    //     'endDate': function(){
    //         this.FetchPendingOrderRequest();
    //     }
    // }
}